module.exports = __webpack_public_path__ + "static/media/banner-welcome-light-2.169d577d.png";